import React from 'react';

export const CertificadosListConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth : ['rh', 'rh_not_signer', 'director', 'funcionario'],
    routes  : [
        {
            path     : '/certificados-list',
            component: React.lazy(() => import('./CertificadosList'))
        }
    ]
};